
import { Vue, Component, Prop } from 'vue-property-decorator'
import * as T from '@/types'
import * as C from '@/constants'
import S from '@/store'

import { formatAbsoluteDate } from '@/utils/utils-datetime'

import { 
    UiCheckbox,
    UiEmptyState,
    UiIcon,
    UiLoadingOverlay,
    UiLoadMoreButton,
    UiTable,
    UiTableHeader,
    UiTableHeaderCellContent,
    UiTableGroupHeader,
    UiTableRow,
    UiTableCellContent,
} from '@hubsolv/hubsolv-ui'

@Component({
    components: {
        UiCheckbox,
        UiEmptyState,
        UiIcon,
        UiLoadingOverlay,
        UiLoadMoreButton,
        UiTable,
        UiTableHeader,
        UiTableHeaderCellContent,
        UiTableGroupHeader,
        UiTableRow,
        UiTableCellContent,
    },
})
export default class ViewCasesTable extends Vue {

    ////////////////////////////////////////////////////////////////
    // Vuex bindings
    ////////////////////////////////////////////////////////////////
    
    @S.Cases.Getter filters!: any

    @S.Cases.Getter sorts!: any
    @S.Cases.Getter sortKeys!: string[]
    @S.Cases.Getter isAscending!: boolean
    
    ////////////////////////////////////////////////////////////////
    // API
    ////////////////////////////////////////////////////////////////

    @Prop({ type: Array, required: true}) items!: any
    @Prop({ type: Boolean, default: false }) loading!: boolean
    
    @Prop({ type: Array, required: true }) selected!: any
    @Prop({ type: Number, required: true }) selectionLimit!: number
    
    @Prop({ type: Array, required: true }) properties!: T.PropertyDefinition<T.File>[]
    @Prop({ type: Array, default: [] }) filterableProperties!: T.PropertyDefinition<T.File>[]

    @Prop({ type: Boolean, default: false }) empty!: boolean
    @Prop({ type: Boolean, default: false }) moreExist!: boolean
    @Prop({ type: Boolean, default: false }) filtersExist!: boolean


    ////////////////////////////////////////////////////////////////
    // computed
    ////////////////////////////////////////////////////////////////

    get columns () {
        return this.properties
    }

    ////////////////////////////////////////////////////////////////
    // Event handlers
    ////////////////////////////////////////////////////////////////

    onClickFilterableCell (key: keyof T.Case, value: string) {
        this.$emit('set-filter', {key, value})
    }
    
    onMouseOver (key: string) {
        this.$emit('highlight-input', key)
    }

    onMouseOut () {
        this.$emit('highlight-input', null)
    }

}
